export default "__VITE_ASSET__58u2YvhE__"